import { gql } from '@apollo/client'

export default gql(`
    mutation createOptaSyncState( 
        $title: String  $lastRunTime: AWSDateTime $frequency: Int $opId: String $isActive: Boolean $isError: Boolean $isRunning: Boolean 
        $isNonOpta: Boolean $baseUrl: String $source: String $enableFasterSync: Boolean
    ) {
        createOptaSyncState(
            input: {
                title: $title
                lastRunTime: $lastRunTime
                frequency: $frequency
                isActive: $isActive
                isError: $isError
                isRunning: $isRunning
                opId: $opId
                isNonOpta: $isNonOpta
                baseUrl: $baseUrl
                source: $source
                enableFasterSync: $enableFasterSync
            }
        ) {
            id
            title
            lastRunTime
            frequency
            opId
            isRunning
            isActive
            isError
            isNonOpta
            baseUrl
            source
            enableFasterSync
        }
    }`
)
